import { render, staticRenderFns } from "./PopularFormulasCards.vue?vue&type=template&id=fad35044&scoped=true&"
import script from "./PopularFormulasCards.vue?vue&type=script&lang=js&"
export * from "./PopularFormulasCards.vue?vue&type=script&lang=js&"
import style0 from "./PopularFormulasCards.vue?vue&type=style&index=0&id=fad35044&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad35044",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardText, BFormRating, BCard, BCardGroup, BToast, BButton} from 'bootstrap-vue'
    installComponents(component, {BCardText, BFormRating, BCard, BCardGroup, BToast, BButton})
    

export default component.exports